<template>
  <div class="manageLayout">
    <header>
      <img
        src="../../public/static/mp_logo_w_min.png"
        alt="MailPublisherHTMLeditor"
        width="220"
        height="58"
        @click="goTopPage"
      >
      <ul class="user-info">
        <li
          class="account"
          @click="isShowAccount = !isShowAccount"
          v-on-clickaway="accountHidden"
        >
          <i class="fas fa-user-circle"></i>
          <transition name="fade">
          <ul class="drop-down-list" v-show="isShowAccount" @click.stop>
            <li @click.stop="accountHidden">
              <router-link :to="{name: 'userSetting'}">ユーザー情報</router-link>
            </li>
            <li @click="logout"><a>ログアウト</a></li>
          </ul>
          </transition>
        </li>
      </ul>
    </header>
    <div class="splitBox">
      <div class="sideNavigationWrapper">
        <side-navigation/>
      </div>
      <div class="mainWrapper">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import sideNavigation from '@/components/Util/SideNavigation'
import { mixin as onClickAway } from 'vue-clickaway'

export default {
  components: {
    sideNavigation,
  },
  mixins: [
    onClickAway
  ],
  data () {
    return {
      isShowAccount: false,
    }
  },
  methods: {
    goTopPage () {
      if (this.$route.name === 'contentList') {
        // contentList にいる場合はリロードする
        this.$router.go(0)
      } else {
        // contentList に移動
        this.$router.push({ name: 'contentList' })
      }
    },
    logout () {
      // サーバーセッション破棄
      this.$http({
        url: '/login/delete',
        type: 'POST',
      })
      this.$utils.token.remove()
      this.$router.push({ name: 'login' })
    },
    accountHidden () {
      this.isShowAccount = false
    }
  }
}
</script>

<style lang="scss" scoped>
.manageLayout {
  min-width: 1280px;
  color: $commonFontColor;
  a {
    color: $commonFontColor;
  }
  header {
    padding-left: 3px;
    height: calc(#{$defaultTopMargin} + #{$navbarHeight});
    line-height: calc(#{$defaultTopMargin} + #{$navbarHeight});
    font-size: 24px;
    font-weight: bold;
    background: #4F5258;
    display: flex;
    justify-content: space-between;
    img {
      cursor: pointer;
      width: 220px;
      height: auto;
      padding: 5px 0;
    }
    .user-info {
      color: #fff;
      font-size: 14px;
      font-weight: normal;
      display: flex;
      align-items: center;
      margin-right: 10px;
      line-height: 16px;
      li {
        margin-left: 15px;
        color: rgba(#fff, 0.6);
        span {
          display: block;
          font-size: 12px;
          opacity: 0.4;
        }
        p {
          text-align: center;
        }
        &.account {
          font-size: 26px;
          margin-left: 10px;
          padding: 10px;
          padding-top: 15px;
          position: relative;
          cursor: pointer;
          transition: all 0.1s ease;
          &:hover {
            color: rgba(#fff, 0.3);
            transition: all 0.1s ease;
            &::after {
              transform: translateY(5px);
              transition: all 0.1s ease;
            }
          }
          &::after {
            content: '';
            display: block;
            font-family: "Font Awesome 5 Free";
            content: '\f107';
            font-weight: 900;
            font-size: 15px;
            text-align: center;
            transition: all 0.1s ease;
          }
          .drop-down-list {
            font-size: 14px;
            white-space: nowrap;
            background: #4F5258;
            padding: 15px 20px;
            left: auto;
            right: 0;
            cursor: default;
            box-shadow: 0 3px 4px rgba($baseFontColor, 0.5);
            li {
              margin: 0;
              cursor: pointer;
              &:hover {
                background: rgba(84, 150, 232, 0.3);
                border-radius: 2px;
                transition: all 0.1s ease;
              }
            }
            a {
              display: block;
              padding: 0 20px;
              color: rgba(#fff, 0.6);
            }
          }
        }
      }
    }
  }
  .splitBox {
    display:-webkit-box;
    display: flex;
    width: 100%;
    .sideNavigationWrapper {
      width: 270px;
      background: $primaryMenuColor;
    }
    .mainWrapper {
      width: 100%;
      height: calc(100vh - (#{$defaultTopMargin} + #{$navbarHeight} + 40px)); // 40pxはpadding
      padding: 20px;
      background: #f8f8f8;
      overflow-y: scroll;
    }
  }
}
</style>
